const Dashboard = () => import('@/views/Dashboard/Dashboard');
const OrganizationSettings = () => import('@/views/OrganizationSettings/OrganizationSettings');
const CustomerCommunicationSettings = () => import('@/views/Dashboard/SystemSettings/CustomerCommunicationSettings/CustomerCommunicationSettings');
const SyncFingerprints = () => import('@/views/SyncFingerprintTask/SyncFingerprintTask');
const SearchResult = () => import('@/views/Dashboard/SearchResult');
const ReceptionDesk = () => import('@/views/Dashboard/ReceptionDesk/ReceptionDesk');
const ReceptionDeskEdit = () => import('@/views/Dashboard/ReceptionDesk/Edit/ReceptionDeskEdit');
const ReceptionDeskIndex = () => import('@/views/Dashboard/ReceptionDesk/Delete/ReceptionDeskIndex');
const Leads = () => import('@/views/Dashboard/Leads');
const PointOfSale = () => import('@/views/Dashboard/PointOfSale');
const Trainers = () => import('@/views/Dashboard/Trainers');
const PersonalSettings = () => import('@/views/Dashboard/PersonalSettings');
const ChangePassword = () => import('@/views/Dashboard/ChangePassword');

export default [
  {
    path: '/',
    name: 'dashboard',
    component: Dashboard,
  },
  {
    path: '/organization/settings',
    name: 'organization-settings',
    component: OrganizationSettings,
  },
  {
    path: '/customer/communication/settings',
    name: 'customer-communication-settings',
    component: CustomerCommunicationSettings,
  },
  {
    path: '/members/sync-fingerprints',
    name: 'member-sync-fingerprint',
    component: SyncFingerprints,
  },
  {
    path: '/member-search/:searchQuery',
    name: 'member-search',
    component: SearchResult,
  },
  {
    path: 'reception-edit/:id',
    name: 'reception-edit',
    component: ReceptionDeskEdit,
  },
  {
    path: '/reception-desk',
    component: ReceptionDeskIndex,
    children: [
      {
        path: '/',
        name: 'reception-desk',
        component: ReceptionDesk,
        meta: { preserveTableState: true },
      },
      {
        path: 'edit/:id',
        name: 'reception-desk-edit',
        component: ReceptionDeskEdit,
      },
    ],
  },
  {
    path: '/leads',
    name: 'leads',
    component: Leads,
  },
  {
    path: '/point-of-sale',
    name: 'point-of-sale',
    component: PointOfSale,
  },
  {
    path: '/trainers',
    name: 'trainers',
    component: Trainers,
  },
  {
    path: 'personal-settings',
    name: 'personal-settings',
    component: PersonalSettings,
  },
  {
    path: 'change-password',
    name: 'change-password',
    component: ChangePassword,
  },
  {
    path: '*',
    component: Dashboard,
  },
];
